export interface State {
  currentProjectId: string | null;
}

export const defaultState: State = {
  currentProjectId: null
};
